(function () {
    'use strict';

    angular
        .module('app')
        .controller('SavedController', SavedController);

    SavedController.$inject = ['$http', '$rootScope', '$state', '$cookies', '$scope', '$filter', 'authenticator', '$stateParams', 'emojiReplacer', 'cache'];

    function SavedController($http, $rootScope, $state, $cookies, $scope, $filter, authenticator, $stateParams, emojiReplacer, cache) {
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        $rootScope.separate_page = false;
        $rootScope.dark_text_header = true;
        var vm = this;
        vm.favouriteMusician = favouriteMusician;
        vm.favouriteHost = favouriteHost;
        vm.goToTab = goToTab;

        vm.$onInit = function () {
            vm.tab = $stateParams.tab;
            window.document.title = $stateParams.language == 'da' ? "Din profil - Be My Concert" : "Your profile - Be My Concert";
            Promise.all([getFavourites()]).then(function () {
            });
        }

        $scope.$on('$destroy', function () {
            $rootScope.dark_text_header = false;
            $rootScope.separate_page = false;
        })

        function getFavourites() {
            $http.get('api/favourites/me/')
                .then(function (response) {
                    vm.musicians = response.data.bands ? response.data.bands : [];
                    vm.hosts = response.data.spaces ? response.data.spaces : [];
                });
        }


        function goToTab(tab){
            vm.tab = tab;
            var scrollY = window.scrollY;
            $state.transitionTo('saved', {tab: tab}, {
                location: true, // This makes it update URL
                inherit: true,
                relative: $state.$current,
                notify: false // This makes it not reload
            }).then(function () {
                window.scrollTo(0, scrollY);
            });
        }

        function favouriteMusician(e, musician) {
            e.preventDefault();
            e.stopPropagation();
            musician['is_favorite'] = '0';
            $http.patch('api/favorite_band/' + musician.band_slug + '/');
            vm.musicians = vm.musicians.filter(musician => musician['is_favorite'] == '1');
            if(cache.exists('musicians')) {
                cache.reset('musicians');
            }
        }

        function favouriteHost(e, host) {
            e.preventDefault();
            e.stopPropagation();
            host['is_favorite'] = false;
            $http.patch('api/favorite_host/' + host.space_slug + '/');
            vm.hosts = vm.hosts.filter(host => host['is_favorite'] == true);
            if(cache.exists('hosts')) {
                cache.reset('hosts');
            }
        }
    }
})();
